import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=aa9d6476"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleListItem: require('/app/components/ArticleListItem.vue').default,SsrCarousel: require('/app/node_modules/vue-ssr-carousel/index.js').default})
